import {setToken, removeToken} from '@/utils'
import {_official_login, _get_user_info} from '@/service/api'
import {request} from '@/service/utils'
export default {
    state :{
        userInfo:{},
    },
    mutations :{
        set_user_info(state, info){
            state.userInfo = info
        },
    },
    actions :{
        officialLogin({dispatch}, loginParams) {
            return new Promise((resolve, reject) => {
                // console.log('axios.post', loginParams)
                request(_official_login, loginParams).then(res => {
                    setToken(res.data.token)
                    dispatch('getUserInfo')
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getUserInfo({commit}){
            return new Promise((resolve, reject) => {
                request(_get_user_info, {}).then(res => {
                    console.log('getUserInfo', res)
                    commit('set_user_info', res.data)
                    resolve()
                }).catch(error => {
                    removeToken()
                    commit('set_user_info',{})
                    reject(error)
                })
            })
        },

        logout({commit}){
            return new Promise((resolve) => {
                removeToken()
                commit('set_user_info',{})
                resolve()
            })
        }
    }
}